var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('thanks_page.step_section.enable_step_section') ? _c('div', {
    staticClass: "p-3"
  }, [_c('SharedStep', {
    attrs: {
      "steps": _vm.getModuleConfig('thanks_page.step_section.steps')
    }
  })], 1) : _vm._e(), _vm.getModuleConfig('thanks_page.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("thanks_page.form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('thanks_page.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("thanks_page.form_desc")) + " ")]) : _vm._e(), _vm.thankContent ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.thankContent)
    }
  }) : _vm._e(), _vm._l(_vm.contentImages, function (image) {
    return _c('img', {
      key: image.order,
      staticClass: "w-100",
      attrs: {
        "src": image.image_url
      }
    });
  }), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('thanks_page.button_text'),
      "button-url": _vm.getModuleConfig('thanks_page.button_url'),
      "type": _vm.getModuleConfig('thanks_page.button_action')
    }
  })], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }